import { Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { CenteredCircularProgress } from '../../../../../common/CenteredCircularProgress';

export const LoadingNewEnvironment = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Box sx={{ padding: '16px 0 24px' }}>
        <CenteredCircularProgress />
      </Box>
      <Typography variant="h4">Adding New Environment...</Typography>
      <Typography variant="caption" color={colors.grey[800]}>
        it might take a few minutes
      </Typography>
    </Box>
  );
};
